/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_GenreInputs */

const en_field_genre = /** @type {(inputs: Field_GenreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const es_field_genre = /** @type {(inputs: Field_GenreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Género`)
};

const fr_field_genre = /** @type {(inputs: Field_GenreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const de_field_genre = /** @type {(inputs: Field_GenreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const ja_field_genre = /** @type {(inputs: Field_GenreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジャンル`)
};

const zh_field_genre = /** @type {(inputs: Field_GenreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型/流派`)
};

const ar_field_genre = /** @type {(inputs: Field_GenreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النوع الفني`)
};

const id_field_genre = /** @type {(inputs: Field_GenreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const it_field_genre = /** @type {(inputs: Field_GenreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genere`)
};

const ru_field_genre = /** @type {(inputs: Field_GenreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанр`)
};

const pt_field_genre = /** @type {(inputs: Field_GenreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gênero`)
};

const ko_field_genre = /** @type {(inputs: Field_GenreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`장르`)
};

/**
* | output |
* | --- |
* | "Genre" |
*
* @param {Field_GenreInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_genre = /** @type {((inputs?: Field_GenreInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_GenreInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_genre(inputs)
	if (locale === "es") return es_field_genre(inputs)
	if (locale === "fr") return fr_field_genre(inputs)
	if (locale === "de") return de_field_genre(inputs)
	if (locale === "ja") return ja_field_genre(inputs)
	if (locale === "zh") return zh_field_genre(inputs)
	if (locale === "ar") return ar_field_genre(inputs)
	if (locale === "id") return id_field_genre(inputs)
	if (locale === "it") return it_field_genre(inputs)
	if (locale === "ru") return ru_field_genre(inputs)
	if (locale === "pt") return pt_field_genre(inputs)
	return ko_field_genre(inputs)
});